// extracted by mini-css-extract-plugin
module.exports = {"main":"noData_main__Shu9V"};